import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { TranslationService } from '@sdbn/common';
import { FilterAdministrationContext } from '../../../../filter-administration.context';
import { FilterCondition } from '../../../../filter-administration.model';
import { FilterDetailsComponent } from '../../../../filter-details-component.model';

@Component({
  selector: 'app-string2-condition-editor',
  templateUrl: './string2-condition-editor.component.html',
  styleUrls: ['./string2-condition-editor.component.scss']
})
export class String2ConditionEditorComponent implements OnInit, OnDestroy, FilterDetailsComponent {

  condition: FilterCondition;

  filterAdministrationContext: FilterAdministrationContext;
  filterAdministrationContextSubscription: Subscription;

  detailsFormGroup = new FormGroup({});

  constructor(
    public translationService: TranslationService
  ) {

    this.detailsFormGroup.addControl('string2', new FormControl('', []));
    this.detailsFormGroup.valueChanges.subscribe(
      value => {
        if (this.detailsFormGroup.dirty) {
          this.condition.data.string2 = this.detailsFormGroup.controls.string2.value;
          this.filterAdministrationContext.getFilter().dirty = true;
        }
      }
    );

  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    if (this.filterAdministrationContextSubscription != null) {
      this.filterAdministrationContextSubscription.unsubscribe();
    }
  }

  setFilterAdministrationContext(filterAdministrationContext: FilterAdministrationContext) {
    this.filterAdministrationContext = filterAdministrationContext;
    this.condition = this.filterAdministrationContext.getSelectedFilterCondition();
    this.resetForm();
    this.filterAdministrationContextSubscription = this.filterAdministrationContext.contextChange$.subscribe(
      change => {
        try {
          if (change.key === 'selected-filter-condition-changed') {
            this.condition = this.filterAdministrationContext.getSelectedFilterCondition();
            this.resetForm();
          }
        } catch (error) {
          console.log(error);
        }
      }
    );
  }

  private resetForm() {
    this.detailsFormGroup.reset(this.condition.data);
  }
}
